import React from 'react';

const CardBody = (props) =>
        <div name="cardRecurso" className="caption card-body carousel-body">
            {props.children}
        </div>

export default CardBody;
